import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as UserCreators } from 'store/ducks/user';
import PageBase from 'components/PageBase';
import ClientView from 'components/Pages/ClientPage/ClientView';
import PropTypes from 'prop-types';

const ViewPage = ({ match }) => {
  const dispatch = useDispatch();

  const [localState, setLocalState] = React.useState(null);

  const [filters, setFilters] = React.useState({
    search: '',
    orderByColumn: 'name',
    orderByDirection: 'asc',
    page: 1,
    perPage: 10,
  });

  const {
    user,
    userLoading,
    dataReport: ActivitiesDone,
    totalReport,
    dataReportChild: ReportChild,
    totalReportChild,
    loadingReportChild,
  } = useSelector(state => state.user);

  const getInitialData = () => {
    const { params } = match;
    dispatch(UserCreators.getUserRequest({ id: params.clientId }));
    setLocalState(null);
  };

  React.useEffect(() => {
    const { params } = match;
    dispatch(
      UserCreators.getReportRequest({
        idUser: params.clientId,
        ...filters,
      }),
    );
  }, [filters]);

  React.useEffect(() => {
    getInitialData();
  }, []);

  React.useEffect(() => {
    const { params } = match;
    if (
      Object.keys(user).length > 0 &&
      !userLoading &&
      user.id === Number(params.clientId)
    ) {
      setLocalState(user);
    }
  }, [user]);

  return (
    <PageBase>
      {localState && (
        <ClientView
          userInfo={localState}
          ActivitiesDone={ActivitiesDone}
          totalReport={totalReport}
          setFilters={setFilters}
          ReportChild={ReportChild}
          totalReportChild={totalReportChild}
          loadingReportChild={loadingReportChild}
        />
      )}
    </PageBase>
  );
};

ViewPage.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default ViewPage;
